import api from "../api";

export const authAPI = {
  signup: (body) => api.post("/api/auth/signup", body).then((r) => r.data),
  login: (email, password) => api.post("/api/auth/login", { email, password }).then((r) => r.data),
  me: () => api.get("/api/auth/me").then((r) => r.data),
  logout: () => api.post("/api/auth/logout").then((r) => r.data),
  updateProfile: (body) => api.put("/api/auth/profile", body).then((r) => r.data),
};

export const productsAPI = {
  list: (params) => api.get("/api/products", { params }).then((r) => r.data),
  get: (id) => api.get(`/api/products/${id}`).then((r) => r.data),
  reviews: (id, params) => api.get(`/api/products/${id}/reviews`, { params }).then((r) => r.data),
  createReview: (id, body) => api.post(`/api/products/${id}/reviews`, body).then((r) => r.data),
};

export const categoriesAPI = {
  list: () => api.get("/api/categories").then((r) => r.data),
};

export const brandsAPI = {
  list: () => api.get("/api/brands").then((r) => r.data),
};

export const featuresAPI = {
  list: () => api.get("/api/features").then((r) => r.data),
};

export const cartAPI = {
  get: () => api.get("/api/cart").then((r) => r.data),
  add: (body) => api.post("/api/cart", body).then((r) => r.data),
  update: (id, qty) => api.put(`/api/cart/${id}`, { qty }).then((r) => r.data),
  remove: (id) => api.delete(`/api/cart/${id}`).then((r) => r.data),
  clear: () => api.delete("/api/cart").then((r) => r.data),
};

export const wishlistAPI = {
  list: () => api.get("/api/wishlist").then((r) => r.data),
  toggle: (productId) => api.post("/api/wishlist", { product_id: productId }).then((r) => r.data),
  remove: (productId) => api.delete(`/api/wishlist/${productId}`).then((r) => r.data),
};

export const ordersAPI = {
  checkout: (body) => api.post("/api/checkout", body).then((r) => r.data),
  list: () => api.get("/api/orders").then((r) => r.data),
  get: (orderNo) => api.get(`/api/orders/${orderNo}`).then((r) => r.data),
  cancel: (orderNo) => api.post(`/api/orders/${orderNo}/cancel`).then((r) => r.data),
};

export const adminAPI = {
  metrics: () => api.get("/api/admin/metrics").then((r) => r.data),
  products: () => api.get("/api/admin/products").then((r) => r.data),
  createProduct: (body) => api.post("/api/admin/products", body).then((r) => r.data),
  updateProduct: (id, body) => api.put(`/api/admin/products/${id}`, body).then((r) => r.data),
  deleteProduct: (id) => api.delete(`/api/admin/products/${id}`).then((r) => r.data),
  detailPages: () => api.get("/api/admin/product-detail-pages").then((r) => r.data),
  createDetailPage: (body) => api.post("/api/admin/product-detail-pages", body).then((r) => r.data),
  detailPage: (productId) =>
    api.get(`/api/admin/product-detail-pages/${productId}`).then((r) => r.data),
  saveDetailPage: (productId, body) =>
    api.put(`/api/admin/product-detail-pages/${productId}`, body).then((r) => r.data),
  uploadDetailImage: (formData) =>
    api
      .post("/api/admin/product-detail-pages/images", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((r) => r.data),
  seoTrends: () => api.get("/api/admin/seo-trends").then((r) => r.data),
  createSeoTrends: (body) => api.post("/api/admin/seo-trends", body).then((r) => r.data),
  updateSeoTrend: (id, body) => api.put(`/api/admin/seo-trends/${id}`, body).then((r) => r.data),
  deleteSeoTrend: (id) => api.delete(`/api/admin/seo-trends/${id}`).then((r) => r.data),
  orders: (params) => api.get("/api/admin/orders", { params }).then((r) => r.data),
  updateOrderStatus: (id, status) =>
    api.put(`/api/admin/orders/${id}/status`, { status }).then((r) => r.data),
  uploadImage: (formData) =>
    api
      .post("/api/admin/upload-image", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((r) => r.data),
};

export const seoAPI = {
  list: () => api.get("/api/seo-trends").then((r) => r.data),
  get: (slug) => api.get(`/api/seo-trends/${slug}`).then((r) => r.data),
};
